module.exports = __webpack_public_path__ + "img/mnx.c0a840db.svg";